/**
 * Commande payée par la CARTE Stripe : le chemin « Payer » des pages
 * adhésion, billetterie et boutique quand le champ carte n'est pas celui de
 * PayPal (le cas PayPal passe par ses CardFields, avant ce chemin).
 *
 * 🔴 POURQUOI (Karim 2026-09-29, /a/adhesion-standard). Le bouton PayPal
 * prépare sa commande en passant le moyen de paiement choisi à « paypal ».
 * Un donateur qui ouvrait PayPal, le refermait puis tapait sa carte et
 * cliquait « Payer » repartait avec « paypal » : le serveur créait une
 * commande PayPal et la page l'envoyait vers la page PayPal — sa carte
 * jamais utilisée.
 */
export function commandeParCarte<T extends object>(payload: T): T & { payment_provider: "stripe" } {
  return { ...payload, payment_provider: "stripe" };
}
